import { IAttribute, IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { BitbucketTableDataset } from 'app/model/dataset/bitbucket.dataset';
import { TabularCopySource } from 'app/model/pipeline/copysource/tabular-type.copysource';

@Metamodel.model({
    name: 'BitbucketSource',
    display: [],
    tags: {
        datasetModel: Metamodel.modelFor(BitbucketTableDataset)
    }
})
export class BitbucketCopySource extends TabularCopySource {
    public static readonly MODEL: IModel;
    public static readonly BATCH_SIZE: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_BatchSize,
        association: 'BATCH_SIZE',
        templatable: true
    })
    public batchSize?: number;
}
